let registrationPromise: Promise<ServiceWorkerRegistration | undefined> | undefined;

async function waitForController(): Promise<void> {
  if (navigator.serviceWorker.controller) return;
  await new Promise<void>((resolve) => {
    navigator.serviceWorker.addEventListener("controllerchange", () => resolve(), { once: true });
  });
}

export function serviceWorkerRegistration(): Promise<ServiceWorkerRegistration | undefined> {
  if (!import.meta.env.PROD || typeof navigator === "undefined" || !("serviceWorker" in navigator)) {
    return Promise.resolve(undefined);
  }

  registrationPromise ??= (async () => {
    const existing = await navigator.serviceWorker.getRegistration("./");
    let registration: ServiceWorkerRegistration;
    try {
      registration =
        existing?.active && !navigator.onLine
          ? existing
          : await navigator.serviceWorker.register("./sw.js", { scope: "./" });
    } catch (error) {
      if (!existing?.active) throw error;
      registration = existing;
    }
    await navigator.serviceWorker.ready;
    await waitForController();
    return registration;
  })();
  return registrationPromise;
}
